// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"109":"06b94cc4","355":"0d38b369","490":"355f12e6"}[chunkId] + ".chunk.js";
};